import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { afficherFichier } from '../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';

const CardSyndic = ({ Nom, Img }) => (
    <Card Titre={CardSyndic.titleName} SousTitre={Nom}>
        <p className="card-text mb-0">
            {Img && (
                <img
                    src={afficherFichier(Img)}
                    alt=""
                    className="rounded mx-auto d-block border border-secondary img-fluid img-logo"
                />
            )}
        </p>
        <Link to={{ pathname: '/MaMessagerie/Ecrire' , state: { Incident: true } }} className="btn btn-outline-danger mt-3 mr-3">
            <i className="fa fa-exclamation-triangle" aria-hidden="true" /> Signaler un problème
        </Link>
        <Link to={'/MaMessagerie/Ecrire'} className="btn btn-outline-primary mt-3 mr-3">
            Contacter
        </Link>
        <Link to="/MonSyndic" className="btn btn-outline-secondary mt-3">
            Voir la fiche
        </Link>
    </Card>
);
CardSyndic.displayName = 'CardSyndic';
CardSyndic.titleName = 'Mon syndic';
CardSyndic.requiredProps = [
    'Nom', // Nom du syndic
    'Img', // Logo du syndic
];

function mapStateToProps({
    SynStore: {
        Syn: {
            Ind: { Nom },
            Img
        },
    },
}) {
    return { Nom, Img };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardSyndic));



// WEBPACK FOOTER //
// ./src/components/Accueil/CardSyndic.js